"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIndexByValue = void 0;
const getIndexByValue = (data, value) => {
    let len = data.length;
    while (len--) {
        if (data[len] && data[len].id === value) {
            return len;
        }
    }
    return 0;
};
exports.getIndexByValue = getIndexByValue;
//# sourceMappingURL=getIndexByValue.js.map